/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Styles from './EmprestimoGarantiaCarroContratoBoletoVenceu.css';
import RedButton from '../../atoms/RedButton/RedButton';
import ContainerHome24 from '@/components/atoms/ContainerHome24';

function EmprestimoGarantiaCarroContratoBoletoVenceu() {
  const [showMsg, setShowMsg] = useState(false);
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);
  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }

  return (
    <>
      <section id="boleto-venceu-contrato">
        <div className="boleto-venceu-mobi">
          {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width <= 320 && (
                <picture>
                  <source
                    type="image/webp"
                    srcSet="assets/emprestimo-garantia-carro-contrato/boleto-venceu/img-boleto-venceu-320.webp"
                  />
                  <source
                    type="image/png"
                    srcSet="assets/emprestimo-garantia-carro-contrato/boleto-venceu/img-boleto-venceu-320.png"
                  />
                  <img
                    src="assets/emprestimo-garantia-carro-contrato/boleto-venceu/img-boleto-venceu-320.png"
                    alt="Pessoa sentada em sofá, usando um notebook sobre a mesa para consultar seu contrato de empréstimo no Santander."
                    className="img-boleto-venceu"
                  />
                </picture>
              )}
              {width > 320 && width <= 450 && (
                <picture>
                  <source
                    type="image/webp"
                    srcSet="assets/emprestimo-garantia-carro-contrato/boleto-venceu/img-boleto-venceu-450.webp"
                  />
                  <source
                    type="image/png"
                    srcSet="assets/emprestimo-garantia-carro-contrato/boleto-venceu/img-boleto-venceu-450.png"
                  />
                  <img
                    src="assets/emprestimo-garantia-carro-contrato/boleto-venceu/img-boleto-venceu-450.png"
                    alt="Pessoa sentada em sofá, usando um notebook sobre a mesa para consultar seu contrato de empréstimo no Santander."
                    className="img-boleto-venceu"
                  />
                </picture>
              )}
              {width > 450 && width <= 600 && (
                <picture>
                  <source
                    type="image/webp"
                    srcSet="assets/emprestimo-garantia-carro-contrato/boleto-venceu/img-boleto-venceu-600.webp"
                  />
                  <source
                    type="image/png"
                    srcSet="assets/emprestimo-garantia-carro-contrato/boleto-venceu/img-boleto-venceu-600.png"
                  />
                  <img
                    src="assets/emprestimo-garantia-carro-contrato/boleto-venceu/img-boleto-venceu-600.png"
                    alt="Pessoa sentada em sofá, usando um notebook sobre a mesa para consultar seu contrato de empréstimo no Santander."
                    className="img-boleto-venceu"
                  />
                </picture>
              )}
              {width > 600 && width <= 992 && (
                <picture>
                  <source
                    type="image/webp"
                    srcSet="assets/emprestimo-garantia-carro-contrato/boleto-venceu/img-boleto-venceu-800.webp"
                  />
                  <source
                    type="image/png"
                    srcSet="assets/emprestimo-garantia-carro-contrato/boleto-venceu/img-boleto-venceu-800.png"
                  />
                  <img
                    src="assets/emprestimo-garantia-carro-contrato/boleto-venceu/img-boleto-venceu-800.png"
                    alt="Pessoa sentada em sofá, usando um notebook sobre a mesa para consultar seu contrato de empréstimo no Santander."
                    className="img-boleto-venceu"
                  />
                </picture>
              )}
            </>
          )}

          <ContainerHome24>
            <h3 className="boleto-venceu-titulo">Seu boleto venceu?</h3>
            <p className="boleto-venceu-texto">
              Ao realizar o pagamento de seu boleto vencido, você evita o aumento dos juros e conta
              com um dia a dia mais confortável para você e sua família. Confira abaixo como gerar a
              2ª via de seu boleto:
            </p>
            <div className="passos-gerar-boleto">
              <p className="passo-gerar-boleto">
                <b>1.</b> Acesse o aplicativo{' '}
                <a
                  href="https://emprestimosim.com.br/app/#/login/signInWithPassword"
                  target="_blank"
                >
                  Sim | Santander
                </a>
              </p>
              <p className="passo-gerar-boleto">
                <b>2.</b> Clique no item do menu Meus contratos;
              </p>
              <p className="passo-gerar-boleto">
                <b>3.</b> Clique em mais opções e então gerar boletos
              </p>
              <p className="passo-gerar-boleto">
                <b>4.</b> Selecione as parcelas que deseja pagar.
              </p>
            </div>
            <RedButton
              href="https://emprestimosim.com.br/app/#/login/signInWithPassword "
              className="btn-boleto-venceu"
              target="_blank"
              rel="noopener"
            >
              Acessar Contrato
            </RedButton>
          </ContainerHome24>
        </div>
        <div className="boleto-venceu-desk">
          <ContainerHome24>
            {typeof window === 'undefined' ? (
              <></>
            ) : (
              <>
                {width > 992 && (
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="assets/emprestimo-garantia-carro-contrato/boleto-venceu/img-boleto-venceu-568.webp"
                    />
                    <source
                      type="image/png"
                      srcSet="assets/emprestimo-garantia-carro-contrato/boleto-venceu/img-boleto-venceu-568.png"
                    />
                    <img
                      src="assets/emprestimo-garantia-carro-contrato/boleto-venceu/img-boleto-venceu-568.png"
                      alt="Pessoa sentada em sofá, usando um notebook sobre a mesa para consultar seu contrato de empréstimo no Santander."
                      className="img-boleto-venceu"
                    />
                  </picture>
                )}
              </>
            )}

            <div className="boleto-venceu-desk-conteudo">
              <h3 className="boleto-venceu-titulo">Seu boleto venceu?</h3>
              <p className="boleto-venceu-texto">
                Ao realizar o pagamento de seu boleto vencido, você evita o aumento dos juros e
                conta com um dia a dia mais confortável para você e sua família. Confira abaixo como
                gerar a 2ª via de seu boleto:
              </p>
              <div className="passos-gerar-boleto">
                <p className="passo-gerar-boleto">
                  <b>1.</b> Acesse o aplicativo{' '}
                  <a
                    href="https://emprestimosim.com.br/app/#/login/signInWithPassword "
                    target="_blank"
                  >
                    Sim | Santander
                  </a>
                </p>
                <p className="passo-gerar-boleto">
                  <b>2.</b> Clique no item do menu Meus contratos;
                </p>
                <p className="passo-gerar-boleto">
                  <b>3.</b> Clique em mais opções e então gerar boletos
                </p>
                <p className="passo-gerar-boleto">
                  <b>4.</b> Selecione as parcelas que deseja pagar.
                </p>
              </div>
              <RedButton
                href="https://emprestimosim.com.br/app/#/login/signInWithPassword "
                className="btn-boleto-venceu"
                wide
                target="_blank"
                rel="noopener"
              >
                Acessar contrato
              </RedButton>
            </div>
          </ContainerHome24>
        </div>
      </section>

      <style jsx>{Styles}</style>
    </>
  );
}

export default EmprestimoGarantiaCarroContratoBoletoVenceu;
